import { I18n } from '@aws-amplify/core';
import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { OWAS_QUERY_KEYS } from '../enums';
import type { BaseContext, OwasCategories, OwasSubCategories } from '@/types';

export type GetOwasLoadResponse = OwasCategories & {
	sub_categories: OwasSubCategories[];
};

type SelectOptions = {
	value: string;
	label: string;
};

async function getLoad(params: BaseContext): Promise<GetOwasLoadResponse> {
	const url = `/ergonomic-tool/owas/category/load`;
	const { data } = await Api.get<GetOwasLoadResponse>(url, { params });
	return data;
}

function formatDataToSelectInput({ sub_categories }: GetOwasLoadResponse): SelectOptions[] {
	const options = sub_categories.map((subCategory) => {
		return {
			value: subCategory.id,
			label: I18n.get(subCategory.description)
		};
	});

	return options;
}

export const useGetOwasLoad = (params: BaseContext) => {
	return useQuery([OWAS_QUERY_KEYS.GET_LOAD], () => getLoad(params), {
		select: formatDataToSelectInput
	});
};
